import _ from 'lodash';
import customHelper from '$$helpers/custom';
import { formatDate } from '../../helpers/dates';
import { getTemplateForResource } from '../../grid/columns/templates/commonColumns';

/**
 * Specifies the text assigned to tasks bars on the right side
 * @param instance
 * @returns {(function(*, *, *): (string|string))|*}
 */
export default instance => (start, end, task) => {
  let text = '';
  const state = instance.getState();
  let borderElement = '';
  let floatBarWidth = '';

  if (instance.config.show_float_time && (instance.config.right_side_text === 'rightSideText' || instance.config.show_resource_avatar)) {
    const specificElement = document.querySelector(`.slack[data-id="${task.id}"]`);

    if (specificElement) {
      floatBarWidth = parseInt(specificElement.style.width, 10);
    }
  }

  if (instance.config.right_side_text === 'rightSideText' && instance.config.show_resource_avatar
    && task.resources && task.resources.length > 0 || task.type !== 'project') {
    if (state.drag_mode !== 'move') {
      borderElement = '<div class="resource_list_in_grid_border" ></div>';
    }
  }
  if (task.type === 'project' && instance.config.right_side_text === 'rightSideText') {
    borderElement = '<div class="project-name-and-dates-separator"></div>';
    const start = formatDate(task.start_date);
    const end = formatDate(task.end_date);
    let projectName = null;

    if (instance.config.multiview && task.$level === 1) {
      const project = instance.ganttDataApi.getProjectItem(task.gantt_id);

      if (project) {
        projectName = customHelper.formatTaskName(project.name).trim();
      }
    } else {
      projectName = customHelper.formatTaskName(task.text).trim();
    }
    text = `<div class='custom-project-name' >${projectName}</div>${borderElement
    }<div class='custom-project-dates'>` + ` ${start} - ${end}</div>`;
  } else if (state.drag_mode !== 'move' && state.drag_mode !== 'resize') {
    const taskName = customHelper.formatTaskName(task.text).trim();

    text = `<div class='custom-task-name' style="${floatBarWidth && !task?.resources?.length ? `margin-left: ${floatBarWidth}px` : ''}">${taskName}</div>`;
  }

  if (instance.config.right_side_text !== 'rightSideText' || task.workloadMode) {
    text = '';
  }

  if (instance.config.show_resource_avatar && task.resources && task.resources.length > 0
    && !task.workloadMode && state.drag_mode !== 'move' && state.drag_mode !== 'resize' && task.type !== 'project') {
    const resourceData = instance.ganttDataApi.getResourcesByTaskIdAndGanttId(task.gantt_id, task.id);

    if (resourceData.length) {
      const count = task.resources.length;
      let html = `<div class="resource_list_in_grid resource-in-grid" data-task-id="${task.id}" style="${floatBarWidth ? `margin-left: ${floatBarWidth}px` : ''}">`;
      let more = 0;

      _.orderBy(resourceData, 'id').forEach((resource, i) => {
        if (count < 4) {
          html += getTemplateForResource(resource);
        } else if (i < 2) {
          html += getTemplateForResource(resource);
        } else if (!more) {
          more = count - 2;
          html += `<span class="resource_list_item_more">+${more}</span>`;
        }
      });
      if (instance.config.right_side_text !== 'rightSideText') {
        html += `</div>${text}`;

        if ((task.deadline && (end.valueOf() < task.deadline.valueOf()))) {
          html += `</div>${text}`;
        }
        if ((task.deadline && (end.valueOf() > task.deadline.valueOf()))) {
          html += `</div>${borderElement}${text}`;
        }
      } else {
        html += `</div>${borderElement}${text}`;
      }

      text = html;
    }
  }

  if (task.deadline && !task.workloadMode && state.drag_mode !== 'move' && state.drag_mode !== 'resize') {
    if (instance.config.right_side_text !== 'rightSideText') {
      borderElement = '';
    }
    if (instance.config.right_side_text !== 'rightSideText' && task.type === 'project') {
      return text;
    }
    if (end.valueOf() > task.deadline.valueOf()) {
      const overdue = Math.ceil(Math.abs((end.getTime() - task.deadline.getTime()) / (24 * 60 * 60 * 1000)));

      text += `${borderElement}<div class="custom-overdue">${__('overdue_deadline_task_text', {
        days: overdue,
      })}</div>`;
    }
  }

  return text;
};
